import { IPartialReducer } from "../../../core/core-redux/reduxTypes";
import { GeoCalcState } from "../../types";
import { updateObject } from "../../../common/util/UpdateObject";

export const loadGeoCalculationsReducer: IPartialReducer<GeoCalcState> = (state, action) => {
    return updateObject(state, {
        geoCalculations: action.data,
        allCalculations: action.data,
    });
};
